((document) => {
    [].slice.call(document.querySelectorAll('[data-password-meter]')).map((el: HTMLElement) => {
        const input = document.getElementById(el.dataset.passwordMeter!) as HTMLInputElement;

        const exprs: { expr: RegExp, count: number }[] = [
            { expr: /[a-z]/, count: 26 },
            { expr: /[A-Z]/, count: 26 },
            { expr: /[0-9]/, count: 10 },
            { expr: /[\\!"#\$%&\'\(\)\*\+,\-\./:;<=>\?@\[\]\^_`\{|\} ~]/, count: 33 }
        ];

        const setProgress = function (width: number, variant: string, text: string) {
            el.style.width = width + '%'
            el.className = 'progress-bar bg-' + variant;
            el.innerText = text;
            el.setAttribute('aria-valuenow', width.toString());
        }

        const update = function () {
            const pwd = input.value;

            if (!pwd) {
                setProgress(0, 'light', '');
                return;
            }

            const chars = exprs.reduce((val, rule) => rule.expr.test(pwd) ? val + rule.count : val, 0);

            const width = 5 * Math.min(20, Math.log10(Math.pow(chars, pwd.length)));

            if (pwd.length < 8) {
                setProgress(Math.min(50, width), 'danger', 'too short');

            } else if (/^\d+$/.test(pwd) || /(.)\1{3}/.test(pwd) || pwd.split('').filter((ch, i) => pwd.indexOf(ch) === i).length <= 2) {
                setProgress(Math.min(50, width), 'danger', 'insecure');

            } else if (width < 75) {
                setProgress(width, 'warning', 'weak');

            } else if (width < 90) {
                setProgress(width, 'info', 'medium');

            } else {
                setProgress(width, 'success', 'strong');
            }
        }

        input.addEventListener("keyup", update);
        input.addEventListener("change", update);

        update();
    });

})(document);